import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { SupportBar } from './SupportBar';

export function Shell() {
  return (
    <div className="app">
      <Sidebar />
      <main className="main">
        <SupportBar />
        <div className="view">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
